import React from 'react';
import { certificates } from '../../portfolio';
import CertificatesPDF from '../Assets/academics-certifactes.pdf'
import './certificates.css';

const Certificates = () => {
    if (!certificates) return null;
    return (
        <section id='certificates' className='section certificates'>
            <h2 className='section__title'>Certificates</h2>
            <p>{ certificates.description }</p>
            <a href={ CertificatesPDF } download="certificates.pdf" className="certificate-link">
                <span className='btn btn--outline'>
                    view-Certificates
                </span>
            </a>
        </section>
    );
};

export default Certificates;
